import { createContext as createReactContext, useContext as useReactContext, } from 'react';
function assert(contentName, value) {
    if (process.env.NODE_ENV !== 'production' && !value) {
        throw new Error(`${contentName}: value was not provided`);
    }
}
export function createRequiredContext(contentName) {
    const Context = createReactContext(null);
    const Provider = Context.Provider;
    const Consumer = Context.Consumer;
    const useContext = () => {
        const value = useReactContext(Context);
        assert(contentName, value);
        return value;
    };
    return {
        Context,
        Provider,
        Consumer,
        useContext,
    };
}
//# sourceMappingURL=createRequiredContext.js.map